interface SaladItem {
  id: number;
  name: string;
  image: string;
}

const saladItems: SaladItem[] = [
  {
    id: 1,
    name: "Rainbow Crunch Bowl",
    image: "Rainbowcrunch.jpg"
  },
  {
    id: 2,
    name: "Vegan Muscle Bowl",
    image: "vegganmuscle.jpg"
  },
  {
    id: 3,
    name: "Sprout Supreme Bowl",
    image: "sproutbowl.jpg"
  },
  {
    id: 4,
    name: "Pro-Paneer Bowl",
    image: "paneerprobowl.jpg"
  },
  {
    id: 5,
    name: "FibreFit Chana Bowl",
    image: "fiberfitchannabowl.jpg"
  },
  {
    id: 6,
    name: "Corn Craze Bowl",
    image: "cornbowl.jpg"
  }
];

export default function NutritionalValue() {
  return (
    <>
      {/* Section Separator */}
      <div className="h-px bg-gradient-to-r from-transparent via-blue-300 to-transparent opacity-30"></div>
      
      {/* Nutrition Facts Carousel Section */}
      <section className="py-24 bg-gradient-to-br from-slate-50 via-gray-50 to-blue-50 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-80 h-80 bg-gradient-to-br from-slate-200/20 to-blue-200/10 rounded-full blur-3xl"></div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-slate-700 via-gray-700 to-blue-600 bg-clip-text text-transparent">
              Nutritional Value
            </h2>
            <p className="text-xl text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Every salad is packed with essential nutrients, vitamins, and minerals.
              See the detailed nutritional breakdown for each of our fresh creations.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            {saladItems.slice(0, 6).map((item, index) => (
              <div key={item.id} className="group bg-white rounded-3xl shadow-xl border border-slate-200 hover:shadow-2xl hover:shadow-slate-500/20 transition-all duration-500 hover:scale-105 overflow-hidden">
                {/* Image Section - 60% with padding */}
                <div className="p-6">
                  <div className="h-48 relative rounded-2xl overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                  </div>
                </div>
                
                {/* Content Section - 40% */}
                <div className="px-6 pb-6">
                  <div className="text-center mb-4">
                    <h3 className="text-xl font-bold text-gray-800 group-hover:text-slate-600 transition-colors mb-1">{item.name}</h3>
                    <p className="text-sm text-gray-600">Per serving</p>
                  </div>

                  <div className="grid grid-cols-2 gap-3 mb-4">
                    <div className="text-center p-3 bg-blue-50 rounded-xl border border-blue-100">
                      <div className="text-lg font-bold text-blue-600 mb-1">{250 + index * 50}</div>
                      <div className="text-blue-700 text-sm">Calories</div>
                    </div>
                    <div className="text-center p-3 bg-indigo-50 rounded-xl border border-indigo-100">
                      <div className="text-lg font-bold text-indigo-600 mb-1">{15 + index * 5}g</div>
                      <div className="text-indigo-700 text-sm">Protein</div>
                    </div>
                    <div className="text-center p-3 bg-purple-50 rounded-xl border border-purple-100">
                      <div className="text-lg font-bold text-purple-600 mb-1">{8 + index * 2}g</div>
                      <div className="text-purple-700 text-sm">Fiber</div>
                    </div>
                    <div className="text-center p-3 bg-slate-50 rounded-xl border border-slate-100">
                      <div className="text-lg font-bold text-slate-600 mb-1">{20 + index * 3}g</div>
                      <div className="text-slate-700 text-sm">Carbs</div>
                    </div>
                  </div>

                  <div className="text-center">
                    <span className="inline-flex items-center px-3 py-1.5 bg-slate-100 text-slate-800 rounded-full text-sm font-medium border border-slate-200">
                      100% Organic
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
